<div class="bearing" [ngStyle]="style"></div>
